export const placeholderText = {
  createReason: 'Masukkan alasan blokir NIK pelanggan',
  updateReason: 'Masukkan alasan blokir NIK pelanggan',
  createReasonDetail: 'Masukkan alasan blokir NIK pelanggan',
  updateReasonDetail: 'Masukkan alasan blokir NIK pelanggan'
};

export const labelText = {
  createReason: 'Alasan Blokir Pelanggan',
  updateReason: 'Alasan Blokir Pelanggan',
  createReasonDetail: 'Pesan Keterangan Blokir di MAP',
  updateReasonDetail: 'Pesan Keterangan Blokir di MAP'
};

export const btnTextSubmit = {
  createReason: 'Tambahkan Data',
  updateReason: 'Perbarui Data',
  createReasonDetail: 'Tambahkan Data',
  updateReasonDetail: 'Perbarui Data'
};
